import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';

var Actionbar = createReactClass({

  render() {
    return (
      <div className="col-md-2 actionbar">
        {this.renderPanel('Aktionen', this.props.actions, 'orange', 'gears')}
        {this.renderPanel('Reports', this.props.reports, 'green', 'cloud-download')}
      </div>
    );
  },

  renderPanel(title, actions, color, icon) {
    if(!actions || actions.length === 0) {
      return null;
    }

    var actionLinks = actions
      .map((action, index) => {
        if (!action.staticContent && !action.onClick) {
          return (
              <div key={title + index} className="action">
                  <Link to={action.to}>{action.title}</Link>
              </div>
          );
        } else {
          return (
              <div key={title + index} className="action">
                  <a href={action.to} onClick={action.onClick}>{action.title}</a>
              </div>
          );
        }
      });

    return (
      <div className={`jarviswidget jarviswidget-color-${color}`} data-widget-editbutton="false">
          <header>
              <span className="widget-icon"> <i className={`fa fa-${icon}`}></i> </span>
              <h2>{title}</h2>
          </header>
          <div>
              <div className="jarviswidget-editbox"></div>
              <div className="widget-body">
                  <div className="table-responsive">
                      {actionLinks}
                  </div>
              </div>
          </div>
      </div>
    );
  }

});

export default Actionbar;



// WEBPACK FOOTER //
// ./src/components/common/Actionbar.js